import { type MutableRefObject, useEffect, useMemo, useState } from "react"

export const useNoticeBar = (parent: MutableRefObject<HTMLDivElement>) => {
    const [activeIndex, setActiveIndex] = useState(0)
    const [isActive, setIsActive] = useState(false)
    useEffect(() => {
        const handleScroll = () => {
            setIsActive(true)
            window.removeEventListener("scroll", handleScroll)
        }
        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])
    useEffect(() => {
        if (!isActive) return
        if (!parent?.current) return
        const length = parent.current.childElementCount
        const timer = setTimeout(() => {
            const index = activeIndex >= length - 1 ? 0 : activeIndex + 1
            setActiveIndex(index)
        }, 3000)
        return () => clearTimeout(timer)
    }, [activeIndex, isActive, parent])
    return useMemo(() => `-${100 * activeIndex}%`, [activeIndex])
}
